import { ResourceHelper } from '..';

export const useResource = () => {
	let resourceHelper = new ResourceHelper();
	return {
		resourceHelper,
		activeResource: resourceHelper.active()
	};
};
